import { type AppsLinkProps, AppsRoutes } from '@wellesley/router'
import { FC } from 'react'

import { LucideIcon } from 'lucide-react'
import { Item } from '../Item'
import { useIsItemActive } from '../hooks/useIsItemActive'

export type AppListSize = 'sm' | 'lg'

type LinkItemProps = {
  link?: AppsRoutes
  props?: AppsLinkProps['props']
  size: AppListSize
  Icon: FC<{ className?: string }> | LucideIcon
  title?: string
  onClick?: () => void
  queryParams?: AppsLinkProps['queryParams']
}

export const LinkItem: FC<LinkItemProps> = ({
  size,
  Icon,
  link,
  props,
  title,
  onClick,
  queryParams,
}) => {
  const isActive = useIsItemActive(link)
  return (
    <Item
      title={title}
      link={link}
      props={props}
      size={size}
      isActive={isActive}
      onClick={onClick}
      queryParams={queryParams}
    >
      <Icon className="h-xs w-6" />
    </Item>
  )
}
